import { createSlice } from '@reduxjs/toolkit';
import { IMAGES } from '@image/images';
import { TableData } from '@uikit/Tables/types';
import { documentsApi } from '@store/rtk/documents';
import { beautifyDateTime } from '@src/utils';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type DocumentsSliceType = {
  physicianCertificationStatementsData: TableData;
  payorDocsData: TableData;
  miscData: TableData;
};

const {
  physicianCertificationStatementsColumns,
  payorDocsColumns,
  miscColumns,
} = TABLE_COLUMNS;

const initialState: DocumentsSliceType = {
  physicianCertificationStatementsData: {
    columns: physicianCertificationStatementsColumns,
    rows: [],
    size: 5,
  },
  payorDocsData: {
    columns: payorDocsColumns,
    rows: [
      {
        id: 1,
        documentRecordID: '9999999999999993',
        uploadedFileName: 'Image01.JPG',
        created: '05/15/2024 05:15 PDT',
        uploadedBy: 'Michael L. (lujanom)',
        role: 'Core user',
        viewImage: IMAGES.modalImg,
      },
      {
        id: 2,
        documentRecordID: '9999999999999993',
        uploadedFileName: 'Scanned Document.PDF',
        created: '05/15/2024 05:00 PDT',
        uploadedBy: 'Angela Q. (angelaq@...)',
        role: 'Rider user',
        viewImage: IMAGES.modalImg,
      },
      {
        id: 3,
        documentRecordID: '9999999999999993',
        uploadedFileName: 'SomethingSomethingDarksideSomething.tif',
        created: '05/15/2024 05:00 PDT',
        uploadedBy: 'Marvin T. (marvint)',
        role: 'Core user',
        viewImage: IMAGES.modalImg,
      },
    ],
  },
  miscData: {
    columns: miscColumns,
    rows: [
      {
        id: 1,
        record_id: '9999999999999993',
        fileName: 'Image01.JPG',
        created: '05/15/2024 05:15 PDT ',
        upload_by: 'Michael L. (lujanom)',
        role: 'Core user',
        viewImage: IMAGES.modalImg,
      },
      {
        id: 2,
        record_id: '9999999999999993',
        fileName: 'Image01.JPG',
        created: '05/15/2024 05:15 PDT ',
        upload_by: 'Michael L. (lujanom)',
        role: 'Core user',
        viewImage: false,
      },
      {
        id: 3,
        record_id: '9999999999999993',
        fileName: 'Image01.JPG',
        created: '05/15/2024 05:15 PDT ',
        upload_by: 'Michael L. (lujanom)',
        role: 'Core user',
        viewImage: IMAGES.modalImg,
      },
    ],
  },
};

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    // Define reducers here
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      documentsApi.endpoints.getPhysicianCertification.matchFulfilled,
      (state, { payload }) => {
        state.physicianCertificationStatementsData = {
          ...state.physicianCertificationStatementsData,
          rows: [
            ...payload.content.map((el, idx) => ({
              ...el,
              id: el.id ? el.id : idx,
              sent: beautifyDateTime(el?.sendingDate),
              effectiveDate: beautifyDateTime(el?.effectiveDate),
              expirationDate: beautifyDateTime(el?.expirationDate),
              sentTo: el?.medicalSpecialty ?? '',
              status: el?.status ?? '',
              modeOfTransport: el?.modOfTransport ?? '',
            })),
          ],
          ...payload,
          requestTablePageChange:
            documentsApi.endpoints.getPhysicianCertification,
        };
      }
    );
  },
});

export const {} = documentsSlice.actions;
export const selectDocuments = (state: { documents: DocumentsSliceType }) =>
  state.documents;
export const documentsReducer = documentsSlice.reducer;
